import { useState, MouseEvent } from "react";
import { Box, Card, CardContent, CardHeader, useTheme } from "@mui/material";
import { LocalCannedResponse } from "@features/annogram/sidebar/state/cannedResponsesSlice";

interface CannedResponseProps extends LocalCannedResponse {
  onSelect?: (id: string) => void;
  onContextMenu?: (id: string, event: MouseEvent<HTMLDivElement>) => void;
}

function CannedResponseItem({
  id,
  title,
  content,
  userName = "Anonymous",
  onSelect,
  onContextMenu,
}: CannedResponseProps) {
  const theme = useTheme();
  const [mouseOver, setMouseOver] = useState(false);

  const handleClick = () => {
    if (onSelect) {
      onSelect(id);
    }
  };

  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (onContextMenu) {
      onContextMenu(id, event);
    }
  };

  return (
    <Card
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      onClick={handleClick}
      onContextMenu={handleContextMenu}
      sx={{
        margin: "0.5rem",
        background: theme.palette.background.default,
        transition: "all 0.3s ease",
        ...(mouseOver && {
          border: `3px solid ${theme.palette.primary.main}`,
          boxShadow: `0px 10px 15px 2px ${theme.palette.primary.light}`,
          transform: "translateY(-7px)",
          borderRadius: "10px",
        }),
      }}
    >
      <CardHeader title={title} sx={{ pb: 0 }} />
      <CardContent sx={{ paddingY: "0" }}>
        <blockquote>{`${content.slice(0, 90).trim()}${
          content.length > 90 ? "…" : ""
        }`}</blockquote>
      </CardContent>
      <Box
        sx={{
          margin: "0.5rem 1rem 0.5rem 0.5rem",
          textAlign: "right",
          fontSize: "10px",
          fontStyle: "italic",
          color: theme.palette.text.secondary,
        }}
      >
        {userName}
      </Box>
    </Card>
  );
}

export default CannedResponseItem;
